import React from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';

import OtoAlert from 'app/components/common/OtoAlert';
import { NormalizedRestaurant } from 'types';
import { hasAnyOrders } from 'utils/restaurant';

export interface IPushNotificationPermissionDeniedProps {
  restaurant: NormalizedRestaurant | null;
}

const PushNotificationPermissionDenied: React.FC<IPushNotificationPermissionDeniedProps> = ({ restaurant }) => {
  if (restaurant && !hasAnyOrders(restaurant)) {
    return null;
  }
  return (
    <OtoAlert color="warning" className="mb-3">
      <div className='h3'>{i18next.t('notifications.permission-denied.title')}</div>
      <p>{i18next.t('notifications.permission-denied.message')}</p>
      <Link to="https://drive.google.com/drive/folders/1802IfFN48IojFgejJgpNyotXV1DuKW7W" target="_blank" rel="noopener noreferrer" className="alert-link d-block h3">
      Zobacz instrukcję
      </Link>
      <Link to="/help" className="alert-link my-2">
        {i18next.t('notifications.permission-denied.contact-support')}
      </Link>
    </OtoAlert>
  );
};

export default PushNotificationPermissionDenied;